(function() {
    'use strict';
    
    function initDropdownContent() {
        const dropdownItems = document.querySelectorAll('.syn-dropdown-content .dropdown-item.has-content');
        
        dropdownItems.forEach(function(item) {
            const header = item.querySelector('.dropdown-header');
            const content = item.querySelector('.dropdown-content');
            
            if (header && content) {
                header.addEventListener('click', function(e) {
                    e.preventDefault();
                    const isExpanded = item.classList.contains('expanded');
                    
                    // Close all other dropdowns
                    dropdownItems.forEach(function(otherItem) {
                        if (otherItem !== item) {
                            otherItem.classList.remove('expanded');
                        }
                    });
                    
                    // Toggle current dropdown
                    if (isExpanded) {
                        item.classList.remove('expanded');
                    } else {
                        item.classList.add('expanded');
                    }
                });
            }
        });
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initDropdownContent);
    } else {
        initDropdownContent();
    }
    
    // Re-initialize for dynamically loaded content
    if (typeof window !== 'undefined') {
        window.initDropdownContent = initDropdownContent;
    }
})();
